// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__34KwQ","footer":"ModalFilter_footer__2MHgi"};